var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconMsExcelLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconMsExcel",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M790.588 959.588h225.883V733.706H790.588v225.882Zm338.824 338.824h225.882v-225.883h-225.882v225.883Zm-338.824 0h225.883v-225.883H790.588v225.883Zm-338.823 0h225.882v-225.883H451.765v225.883Zm0-338.824h225.882V733.706H451.765v225.882Zm903.53-677.647v451.765h451.764v903.53H112.94V281.94h1242.353Zm112.94 23.379 315.445 315.445h-315.445V305.32Zm402.184 242.485L1541.195 218.58c-31.51-31.51-75.219-49.581-119.717-49.581H0v1581.176h1920V667.522c0-45.176-17.619-87.755-49.581-119.717Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconMsExcelLine.glyphName = 'ms-excel';
IconMsExcelLine.variant = 'Line';
IconMsExcelLine.displayName = 'IconMsExcelLine';
IconMsExcelLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMsExcelLine;
export { IconMsExcelLine };